import PricingPlan from './PricingPlan.component';

export default PricingPlan;